/** CoStar.Api.Analytics.CommonEntities.Enums.DataSource.DataSourceType */
export var DataSourceType;
(function (DataSourceType) {
    DataSourceType[DataSourceType["Unknown"] = 0] = "Unknown";
    DataSourceType[DataSourceType["SnapShot"] = 1] = "SnapShot";
    DataSourceType[DataSourceType["LatestAvailable"] = 2] = "LatestAvailable";
})(DataSourceType || (DataSourceType = {}));
